import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import fallbackEntitiesIdp from './entitiesIdp.json';

interface EntityProvider {
  entity_id: string;
  logo_uri: string;
  file_name: string;
  file_hash: string;
  code: string;
  signing_certificate_x509: string[];
  organization_name: string;
  organization_display_name: string;
  single_logout_service: Array<{
    Binding: string;
    Location: string;
  }>;
  single_sign_on_service: Array<{
    Binding: string;
    Location: string;
  }>;
  attribute: string[];
  extensions: {
    supported_acr: string[];
    supported_purpose: string[];
  };
  /** YYYY-MM-DD HH:MM:SS */
  create_date: string;
  /** YYYY-MM-DD HH:MM:SS */
  lastupdate_date: string;
  delete_date: string | null;
  _deleted: string;
  _disabled: string;
  registry_link: string;
}

function shuffle<T>(input: T[]): T[] {
  return input
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

/**
 * Hook per la chiamata a spid.gov che ritorna l'elenco degli IDP
 */
export function useEntitiesIdp() {
  const [data, setData] = useState<EntityProvider[]>(
    shuffle(fallbackEntitiesIdp),
  );

  const isFetching = useRef(false);

  useEffect(() => {
    const fecthData = async () => {
      if (isFetching.current) {
        return;
      }
      isFetching.current = true;
      try {
        const result = await axios.request<EntityProvider[]>({
          url: `https://registry.spid.gov.it/entities-idp?&output=json`,
          method: 'get',
          withCredentials: false,
        });
        // Se il result corrisponde al fallback, non faccio nulla
        const isEqual = result.data.every(item =>
          fallbackEntitiesIdp.some(
            fallback => fallback.entity_id === item.entity_id,
          ),
        );
        if (isEqual) {
          return;
        }

        // Imposto i dati ricevuti, mescolati come richiesto dalla specifica SPID
        setData(shuffle(result.data));
      } catch (e) {
        console.error('[ERROR] Si è verificato un errore durante il caricamento degli IDP, verrà utilizzato il fallback', e); // prettier-ignore
        setData(fallbackEntitiesIdp);
      }
    };
    fecthData();
  }, []);

  return { data };
}
